<template>
  <v-container>
        <div class="mx-5">
            <v-dialog v-model="dialogRoute" max-width="500" persistent>
                <v-card class="pa-7" color="#e0e0e0" >
                    <v-card-text class="text-center">
                        <v-avatar color="white" size="90" class="mt-n3">
                            <v-icon color="green" x-large>mdi-check-bold</v-icon>
                        </v-avatar>
                    </v-card-text>
                    <v-card-text class="text-center black--text">{{msg}}. </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn to="/login">Login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class=" black--text">Reset Password</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" class="mt-4">
                        <v-row no-gutters >
                            <v-col cols="12" sm="4">
                                Old Password
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    solo
                                    dense
                                    v-model="oldpassword"
                                    color="#48c074" 
                                    class="mt-2"
                                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                    :type="show1 ? 'text' : 'password'"
                                    @click:append="show1 = !show1" :rules="oldPasswordRules"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                New Password
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                solo dense class="mt-n2"
                                v-model="newpassword" 
                                color="#48c074" 
                                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                                :type="show2 ? 'text' : 'password'"
                                @click:append="show2 = !show2" :rules="newPasswordRules"
                                ></v-text-field>
                        
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#48c074" text @click="dialog=false">CANCEL</v-btn>
                    <v-btn color="#48c074" :loading="loading" text @click="change()">Change</v-btn>
                
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialogEdit" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class=" black--text">Edit Profile</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form2" class="mt-4">
                        <v-row no-gutters >
                            <v-col cols="12" sm="4">
                                Email
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    solo
                                    dense
                                    v-model="userById.email"
                                    color="#002B49" 
                                    class="mt-n2"
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters >
                            <v-col cols="12" sm="4">
                                First Name
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    solo
                                    dense
                                    v-model="userById.firstname"
                                    color="#002B49" 
                                    class="mt-n2"
                                    :rules="nameRules"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters >
                            <v-col cols="12" sm="4">
                                Last Name
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    solo
                                    dense
                                    v-model="userById.lastname"
                                    color="#002B49" 
                                    class="mt-n2"
                                    :rules="nameRules2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters >
                            <v-col cols="12" sm="4">
                                Update Profile Picture
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-file-input accept='image/*' label="Profile url"  color="#002b49" background-color="#f5f3fc" solo flat dense @change="imageUrl($event)" ref="profileUrl"></v-file-input>
                                <p class="green--text mt-n6 pt-0" v-if="disabled">please wait, loading image...<span class="fa fa-circle-o-notch fa-spin"></span></p>
                            </v-col>
                        </v-row>
                        
                        <!-- <v-row no-gutters >
                            <v-col cols="12" sm="4">
                                Bank Name
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    solo
                                    dense
                                    v-model="userById.lastname"
                                    color="#002B49" 
                                    class="mt-n2"
                                    :rules="nameRules"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters >
                            <v-col cols="12" sm="4">
                                Address
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-textarea
                                    solo
                                    v-model="userById.designation"
                                    color="#002B49" 
                                    class="mt-n2"
                                    :rules='addressRules'
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-select :items="banks" v-model="bank" solo dense label="Bank you transferred from" color="#40e0d0" autofocus=""></v-select> -->
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#48c074" text @click="dialogEdit=false">CANCEL</v-btn>
                    <v-btn v-if="!disabled" color="#48c074" :loading="loading" text @click="editProfile()">Update</v-btn>
                    <v-btn disabled v-if="disabled">Update</v-btn>
                
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="alert" :timeout="10000" top color="white">
            <span :class="msgColor">{{msg}}</span>
            <v-icon @click="alert = false" :color="color">mdi-close</v-icon>
        </v-snackbar>
        <h1 class="grey--text title">ADMIN PROFILE</h1>
        <v-row justify='center' align='center'>
            <v-col cols="12" md="6" sm="12">
                <v-card
                    style="border:1px solid #48c074"
                    hover
                    class="mt-12 pa-2"
                >
                    <v-card-title class="mt-n12 mx-auto">
                        <v-avatar size="120" class="mt-n8 mx-auto">
                            <v-img dark :src="getImageUrl(userById.profile_img_url)"></v-img>
                        </v-avatar>
                    </v-card-title>
                    <v-row justify="center" no-gutters>
                        <v-col>
                            <v-subheader class="float-right title1 font-weight-bold">Name</v-subheader>
                        </v-col>
                        <v-col class="mt-3">
                            <span class="" style="color:#292929">{{userById.firstname}} {{userById.lastname}}</span>
                        </v-col> 
                    </v-row>
                    <v-row justify="center" no-gutters>
                        <v-col>
                            <v-subheader class="float-right font-weight-bold">Email</v-subheader>
                        </v-col>
                        <v-col class="mt-3">
                            <span class="" style="color:#292929">{{userById.email}}</span>
                        </v-col>
                    </v-row>
                    <v-row justify="center" no-gutters>
                        <v-col>
                            <v-subheader class="float-right title1 font-weight-bold">Admin</v-subheader>
                        </v-col>
                        <v-col class="mt-3">
                            <span class="" style="color:#292929">{{userById.isAdmin}}</span>
                        </v-col>
                    </v-row>
                    <v-row justify="center" no-gutters>
                        <v-col>
                            <v-subheader class="float-right title1 font-weight-bold">Status</v-subheader>
                        </v-col>
                        <v-col class="mt-3">
                            <span>Verified</span>
                            <!-- <span class="font-weight-bold" style="color:green" v-if="userById.accountStatus==='Verified'">{{userById.accountStatus}}</span>
                            <span class="font-weight-bold" style="color:red" v-else>{{userById.accountStatus}}</span> -->
                        </v-col>
                    </v-row>
                    <v-row justify="center" no-gutters>
                        <v-col>
                            <v-subheader class="float-right title1 font-weight-bold">Date Created</v-subheader>
                        </v-col>
                        <v-col class="mt-3">
                            <span class="" style="color:#292929">{{userById.date_created}}</span>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#48c074" dark @click="dialogEdit=true">Edit Profile</v-btn>
                        <v-btn text @click="dialog=true">Reset Password</v-btn>
                    </v-card-actions>
                    
                </v-card>
            </v-col> 
        </v-row>
        </div>
        
    </v-container>
</template>

<script>
export default {
    data(){
        return{
            dialog:false,
            show1:false,
            show2:false,
            oldPassword:'',
            newPassword:'',
            loading:false,
            alert:false,
            msgColor:'',
            msg:'',
            color:'',
            oldPasswordRules:[v => !!v || 'Current Password is required'],
            addressRules:[v => !!v || 'Address is required'],
            nameRules:[v => !!v || 'First name  is required'],
            nameRules2:[v => !!v || 'Last name  is required'],
            imageRules:[v => !!v || 'Image is required'],
            newPasswordRules: [v => !!v || 'New Password is required',
                v => v.length > 5 || 'New Password must not be less than 6 characters'
            ],
            dialogEdit:false,
            dialogRoute:false,
            banks:['Access Bank', 'Access Bank (Diamond)', 'ALAT by WEMA', 'ASO Savings and Loans', 'Citibank Nigeria', 'Ecobank Nigeria', 'Ekondo Microfinance Bank', 'Fidelity Bank', 'First Bank of Nigeria', 'First City Monument Bank (FCMB)', 'Guaranty Trust Bank', 'Heritage Bank', 'Jaiz Bank', 'Keystone Bank', 'Kuda Bank', 'PAGA (PAGATECH)', 'Parallex Bank', 'Polaris Bank', 'Providus Bank', 'Stanbic IBTC Bank', 'Standard Chartered Bank', 'Sterling Bank', 'Suntrust Bank', 'Union Bank of Nigeria', 'United Bank For Africa (UBA)', 'Unity Bank', 'Wema Bank', 'Zenith Bank', 'Bank is not Listed'],
            disabled:false,
            profileUrl:this.$store.state.auth.logindetails.data.profile_img_url
        }
    },
    computed:{
        userById(){
            let user= this.$store.state.auth.logindetails.data
            user.date_created = user.date_created.slice(0, 19).replace('T', ' ')
            return user
        }
    },
    methods:{
        change(){
            if (this.$refs.form.validate()){
                this.loading = true
                this.$store.dispatch("ChangePassword",{
                    "oldpassword": this.oldpassword,
                    "newpassword": this.newpassword,
                    "adminId": this.$store.state.auth.logindetails.adminId 
                })
                .then(()=>{
                    window.localStorage.removeItem("token")
                    window.localStorage.removeItem("vuex")
                    this.loading = false
                    this.dialog=false
                    this.msgColor='green--text'
                    this.msg=`Password Updated Successfully.`
                    this.color='green'
                    this.alert=true
                    this.dialogRoute=true
                    
                })
                .catch((error)=>{
                    this.msgColor='red--text'
                    this.msg=error.response.data.message.toUpperCase()
                    this.color='red'
                    this.alert=true
                    this.loading = false
                })
            }
            
        },
        editProfile(){

            if (this.$refs.form2.validate()){
                this.loading = true
                this.$store.dispatch("EditProfile", {
                    "firstname": this.userById.firstname,
                    "lastname": this.userById.lastname,
                    "profileUrl": this.profileUrl 
                })
                .then(()=>{
                    this.loading = false
                    this.dialogEdit=false
                    this.msgColor='green--text'
                    this.msg=`Profile Updated Successfully.`
                    this.color='green'
                    this.alert=true
                    this.$store.dispatch("GetLoggedUser", this.$store.state.auth.logindetails.data._id)
                })
                .catch((error)=>{
                    this.msgColor='red--text'
                    this.msg=error.response.data.message.toUpperCase()
                    this.color='red'
                    this.alert=true
                    this.loading = false
                })
            }
            
        },
        getImageUrl(url){
            if(url!==""&&url!=='undefined'&&url!==null){
                return url
            }else{
                return('/pics.svg')
            }
        },
        imageUrl(e){
            if(e.name!==""){
                this.disabled=true
                this.$store.dispatch("GetImageUrl", {'file':e})
                .then((success)=>{
                    this.profileUrl = success.data.data
                    this.disabled= false
                })
                .catch(()=>{
                })
            }
        },

    }
}
</script>

<style>

</style>